import "./Services.css";

const Services = () => {
  return (
    <section className="services" id = "services">
      <div className="services-container">

        <div className="services-header">
          <span className="services-tag">OUR SERVICES</span>
          <h2>
            What We <span>Build</span>
          </h2>
        </div>

        <div className="services-grid">

          <div className="service-card">
            <div className="icon">🌐</div>
            <h3>Web Development</h3>
            <p>
              Custom websites, enterprise portals, eCommerce platforms,
              and web apps built with modern frameworks.
            </p>
            {/*<a href="#">Learn More →</a>*/}
          </div>

          <div className="service-card">
            <div className="icon">📱</div>
            <h3>Mobile App Development</h3>
            <p>
              iOS & Android apps with seamless UI/UX, performance
              optimization, and scalable backend systems.
            </p>
            {/*<a href="#">Learn More →</a>*/}
          </div>

          <div className="service-card">
            <div className="icon">⚙️</div>
            <h3>Software Development</h3>
            <p>
              Custom business software, SaaS platforms, CRM/ERP systems,
              and automation tools.
            </p>
            {/*<a href="#">Learn More →</a>*/}
          </div>

          <div className="service-card">
            <div className="icon">🎮</div>
            <h3>Game Development</h3>
            <p>
              2D & 3D games, mobile games, PC games, multiplayer systems,
              and immersive gaming experiences.
            </p>
            {/*<a href="#">Learn More →</a>*/}
          </div>

        </div>
      </div>
    </section>
  );
};

export default Services;
